import { Component, type ErrorInfo, type ReactNode } from "react";
import { copy } from "../lib/copy";

type Props = { children: ReactNode };
type State = { failed: boolean };

/** Hooks can't catch render errors, so this one stays a class. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="mx-auto flex h-full max-w-md flex-col items-center justify-center gap-4 px-8 text-center">
        <p className="text-body text-muted">{copy.states.saveFailed}</p>
        <button
          type="button"
          onClick={() => this.setState({ failed: false })}
          className="rounded-pill bg-accent px-5 text-body font-medium text-on-accent"
        >
          {copy.states.retry}
        </button>
      </div>
    );
  }
}
